import { useEffect, useMemo, useState } from 'react';

export interface ClientPagination<T> {
  readonly page: number;
  readonly pageSize: number;
  readonly pageItems: readonly T[];
  readonly setPage: (page: number) => void;
  readonly setPageSize: (pageSize: number) => void;
}

/** Paginação local para coleções que a API já entrega completas. */
export function useClientPagination<T>(items: readonly T[], resetKeys: readonly unknown[] = []): ClientPagination<T> {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeState] = useState(30);
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));

  useEffect(() => {
    setPage(1);
  }, resetKeys);

  useEffect(() => {
    setPage((current) => Math.min(current, totalPages));
  }, [totalPages]);

  const pageItems = useMemo(() => {
    const start = (page - 1) * pageSize;
    return items.slice(start, start + pageSize);
  }, [items, page, pageSize]);

  const setPageSize = (nextPageSize: number) => {
    setPageSizeState(nextPageSize);
    setPage(1);
  };

  return { page, pageSize, pageItems, setPage, setPageSize };
}
